export default "__VITE_ASSET__CDYiJ0AS__"